import React, {Component} from "react";
import {Button, Modal} from "semantic-ui-react";
import ReactMarkdown from 'react-markdown'

export default class DawidDisclaimer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpened: true,
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return !(this.props.disclaimer === nextProps.disclaimer && nextState.modalOpened === this.state.modalOpened)
    }


    render() {
        const {disclaimer} = this.props;
        const {modalOpened} = this.state;
        const {title, body} = disclaimer;
        return (<Modal closeOnEscape={false}
                       closeOnDimmerClick={false} open={modalOpened} onClose={() => {
            this.setState({modalOpened: false})
        }}>
            <Modal.Header>{title}</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <React.Fragment>
                        {body.map((paragraph, index) => <React.Fragment
                            key={index}><ReactMarkdown>{paragraph}</ReactMarkdown></React.Fragment>)}
                    </React.Fragment>
                    <p key={"pButton"} style={{cursor: 'pointer', textAlign: 'center', marginTop: "20px"}}><Button
                        id={"acknowledge-disclaimer"}
                        onClick={() => this.setState({modalOpened: false})}
                        tabIndex={1}
                        content={"I acknowledge"}/></p>
                </Modal.Description>
            </Modal.Content>
        </Modal>)
    }


}